import { createContext, useContext } from "react";

import type { QueryKey } from "./queryKey";
import type { Variables } from "./graphql";

export interface MountQueryKeyContext {
  onMountQueryKey: <TVars extends Variables | undefined = undefined>(
    queryKey: QueryKey<TVars>,
  ) => void;
}

export const MountQueryKeyContext = createContext<MountQueryKeyContext>({
  onMountQueryKey: () => {},
});

export const useMountQueryKey = (): MountQueryKeyContext => {
  return useContext(MountQueryKeyContext);
};
